import React, { useEffect, useRef, useState } from 'react';
import { sendData } from '../../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
// import Layout from '../../../components/layout/Layout';
import { useHistory, useLocation } from "react-router-dom";
import * as Icon from "ubs-icons";
import { isElectron, isMobileDevice } from "ubs-framework/v2/common/function";
import { checkCookie, getCookie } from 'ubs-framework/v2/common/function';
import useSocket from "../../common/useSocket";
import UInput from "ubs-framework/v2/UInput";
import Validator from "simple-react-validator"
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import UPopup from "ubs-framework/v2/UPopup";
import AppHeader from "../../common/components/app-header";
import { COLOR, SIGNUP_STEPS } from "../../../common/constant";
import { detectDevice, showToastSuccess } from 'ubs-framework/v2/common/function';
import { withRouter } from "../../../common/hocs/routing-hoc";
import axios from 'axios';
import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";
import Layout from '../../../components/layout-v2';

let interval = null
const OTP_TIMEOUT = 30;

function useQuery() {
    const query = new URLSearchParams(useLocation().search);
    const queryParams = {};
    query.forEach((value, key) => {
        queryParams[key] = value;
    });
    return queryParams;
}

function Login(props) {
    const params = useQuery();
    console.log(`params ::::`, params);
    const dispatch = useDispatch();
    const history = useHistory();
    const CloseModal = useRef("u_select-place");
    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: { forceUpdate }
    }));

    const [errorMsg, setErrorMsg] = useState("");
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [loginDetail, setLoginDetail] = useState({
        identifier: "",
        password: "",
        platform: detectDevice(true),
    })
    const [hide, setHide] = useState(false)
    const [logoURL, setLogoURL] = useState(localStorage.getItem("selectedLogo") || "");
    const [seconds, setSeconds] = useState(0);
    const [win, setWin] = useState(null)

    const { on, off, refresh } = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'login':
                    const slugType = localStorage.getItem('slugType') || 'track'
                    if ([2]?.includes(res?.data?.signUpStep)) history.push(`/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}`)
                    else if ([3]?.includes(res?.data?.signUpStep)) history.push(`/${res?.data?.orgId}/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}`)


                    else if (res.data.aftrp) history.push("/change-password")
                    else if (res.data.activateAccount) history.push("/verify-email")
                    else if (res?.data?.isCompanyMFA) {
                        setDisabledBtn(false)
                        setSeconds(OTP_TIMEOUT)
                        if (res?.data?.isUserMFASetup) {
                            dispatch({ type: 'SET_LOG_IN_DETAILS', payload: { ...res?.data, identifier: loginDetail?.identifier, password: loginDetail?.password } })
                            history.push('/multi-factor-authenticate')
                        }
                    }
                    else if (checkCookie('previousURL')) window.location.href = getCookie('previousURL')
                    else {
                        setDisabledBtn(true)
                        history.push(`/${res?.data?.orgId}/manage`)
                    }
                    break;
                default:
                    return true;
            }
        } else {
            setErrorMsg(res.data.error)
            setDisabledBtn(false)
            setTimeout(() => setErrorMsg(res.data.error), 5000)
            if (res?.data?.isCompanyMFA) {
                if (!res?.data?.isUserMFASetup) {
                    dispatch({ type: 'SET_LOG_IN_DETAILS', payload: { ...res?.data, identifier: loginDetail?.identifier, password: loginDetail?.password } })
                    history.push('/setup-multi-factor')
                } else {
                    dispatch({ type: 'SET_LOG_IN_DETAILS', payload: { ...res?.data, identifier: loginDetail?.identifier, password: loginDetail?.password } })
                    history.push('/multi-factor-authenticate')
                }
            }
        }
    }
    )

    const onSubmit = (data) => {
        data.preventDefault()
        if (validator?.current?.allValid()) {
            setDisabledBtn(true)
            dispatch({ type: 'SET_EMAIL', payload: data });
            if (params?.client_id) {
                const data = {
                    ...loginDetail,
                    email: loginDetail?.identifier
                }

                axios.post(`${process.env.REACT_APP_ACCOUNT_SOCKET_URL}/oauth2/login?client_id=${params?.client_id}&state=${params?.state}&redirect_uri=${params?.redirect_uri}&identifier=${params?.identifier}`, data).then(res => {
                    if (res?.data?.data?.redirect_uri) {
                        window.location.href = res?.data?.data?.redirect_uri
                    }
                })
            } else {
                const requestData = JSON.parse(JSON.stringify(loginDetail));
                if (isElectron()) requestData.appVersion = window?.electron?.remote?.app?.getVersion();
                sendData(dispatch, 'login', requestData);
            }
        } else {
            validator?.current?.showMessages()
        }
    }

    const inputEvent = (e) => {
        let { name, value } = e.target;
        value = value.replace(/^\s+/g, '').trim()
        setLoginDetail((val) => {
            return { ...val, [name]: value }
        })
    }
    const onKeyUp = e => {
        if (e.key === "Enter") onSubmit(e)
    }
    const microsoft = (data) => {
        if (!disabledBtn) {
            const w = window.open(`${process.env.REACT_APP_ACCOUNT_SOCKET_URL}/auth/ms/login`, "", "width=400, height=600")
            setWin(w)
        }
    }

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if (params.code) {
            localStorage.setItem('code', params.code)
            window?.close()
        }
        if (params.affiliatecode !== undefined) localStorage.setItem('affiliatecode', params.affiliatecode)
        if (params.usercode !== undefined) localStorage.setItem('usercode', params.usercode)
        document?.getElementsByClassName("u_acc-form").autofocus;
        refresh()
        return () => off()
    }, [loginDetail])

    useEffect(() => {
        const interval = setInterval(() => {
            if (win?.closed) {
                const code = localStorage.getItem('code')
                if (code) sendData(dispatch, "msLogin", { code: code })
                clearInterval(interval);
                setWin(null); // Clear the reference
            }
        }, 500); // Check every 500ms
        return () => clearInterval(interval);
    }, [win])

    useEffect(() => {
        if (seconds === OTP_TIMEOUT) {
            clearInterval(interval)
            interval = setInterval(() => {
                setSeconds(prevState => {
                    if (prevState === 1) {
                        clearInterval(interval)
                        return 0
                    } else return prevState - 1
                })
            }, 1000)
        }
        // return () => clearInterval(interval)
    }, [seconds]);

    return (
        <React.Fragment>
            <Layout module="login">
                {logoURL && (
                    <div className="top-right-logo">
                        <img className="u_logo-top" height={70} width={70} src={logoURL} alt="Logo" />
                    </div>
                )}
                <div className="u_p-24" ref={CloseModal}>
                    <div>
                        <div className="u_flex u_content-center">
                            <img src="../images/images/superworks-logo.png" height={40} />
                        </div>
                        <h3 className="u_title u_text-center u_text-bold u_mt-16 u_mb-24">Sign in to your account</h3>
                    </div>
                    <div className="u_row u_content-center u_mt-24">
                        {/*<div className="u_border-radius-8 u_b-light u_mr-8 u_p-10">*/}
                        {/*    <Icon.Google size="18" />*/}
                        {/*</div>*/}
                        {/*<div className="u_border-radius-8 u_b-light u_mr-8 u_p-10">*/}
                        {/*    <Icon.Apple size="18" fill={COLOR.u_title} />*/}
                        {/*</div>*/}
                        <div className="u_border-radius-8 u_b-light u_mr-8 u_p-10 u_cp" onClick={microsoft} >
                            <Icon.Microsoft size="18" />
                        </div>
                        {/*<div className="u_border-radius-8 u_b-light u_mr-8 u_p-10">*/}
                        {/*    <Icon.Linked size="18" fill="#0073C5" />*/}
                        {/*</div>*/}
                        {/*<div className="u_border-radius-8 u_b-light u_p-10">*/}
                        {/*    <Icon.Facebook size="18" fill={COLOR.u_blue} />*/}
                        {/*</div>*/}
                    </div>


                    <div className="u_or-divider">
                        <p className="u_small-font u_px-16">OR</p>
                    </div>
                    <UInput
                        hasError={validator?.current?.message("identifier", loginDetail?.identifier, "required")}
                        className="u_mb-20"
                        label="Email Address / User Name"
                        asterisk
                        testId={TEST_ID.SIGNUP_LOGIN.EMAIL_WRAPPER}>
                        <input
                            onChange={inputEvent}
                            value={loginDetail.identifier}
                            type="text"
                            onKeyUp={onKeyUp}
                            name="identifier"
                            placeholder=" "
                            data-testid={TEST_ID.SIGNUP_LOGIN.EMAIL_INPUT} />
                    </UInput>
                    <UInput
                        className="u_mb-20"
                        password
                        label="Password"
                        asterisk
                        hasError={validator?.current?.message("password", loginDetail?.password, "required|min:8")}
                        testId={TEST_ID.SIGNUP_LOGIN.PASSWORD_WRAPPER}>
                        <input
                            onChange={inputEvent}
                            value={loginDetail.password}
                            type={`${hide ? "text" : "password"}`}
                            autoComplete="off"
                            onKeyUp={onKeyUp}
                            name="password"
                            placeholder=" "
                            data-testid={TEST_ID.SIGNUP_LOGIN.PASSWORD_INPUT} />
                        <div className="u_input-note u_ib">
                            <UPopup params={{ className: "u_tooltip u_tooltip-full", disabled: isMobileDevice() }}
                                desc={<span>{!hide ? "Show Password" : "Hide Password"} </span>}>

                                <span className="u_rollover u_cp u_flex" onClick={() => setHide(!hide)} data-testid={TEST_ID.SIGNUP_LOGIN.PASSWORD_TOGGLE} >{!hide ?
                                    <Icon.HideEye size={18} fill={COLOR.u_icon_bg} /> :
                                    <Icon.Eye size={18} fill={COLOR.u_icon_bg} />}</span>
                            </UPopup>
                        </div>
                    </UInput>
                    {errorMsg?.length !== 0 && <p className="u_error-message">{errorMsg}</p>}
                    {<div className="u_forgotpass">
                        <span onClick={() => history.push(props?.projectRoutes?.forgot || '/forgot-password')} className="u_forgotpass__link u_cp" data-testid={TEST_ID.SIGNUP_LOGIN.FORGOT_PASSWORD_LINK}>Forgot Password?</span>
                    </div>}
                    <div className="u_block u_relative">
                        <button
                            disabled={disabledBtn}
                            type="button"
                            onClick={onSubmit}
                            className={`u_acc-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}
                            data-testid={TEST_ID.SIGNUP_LOGIN.SUBMIT_BUTTON}>Login</button>
                        {disabledBtn && <div className="u_btn-loader"><Icon.Preloader size={70} /></div>}
                    </div>
                </div>
            </Layout>
        </React.Fragment>
    );
}

export default withRouter(Login);
